// Module
var code = `<div class="alert-selector" style="{{>visibility}}">
    <terceraLabel visible="{{visible}}" text="{{label}}" />

    <div class="alert-selector-right">
        <terceraMultiComboBox showLastValue="true"
                              items="{{items}}"
                              visible="{{visible}}"
                              enabled="{{enabled}}"
                              allItemsSelectedText="{{allItemsSelectedText}}"
                              noItemsSelectedText="{{noItemsSelectedText}}"
                              fewItemsSelectedPostfixText="{{fewItemsSelectedPostfixText}}"
                              on-ValueChange="selectionValueChange"
                              hideAll="true"
                              useLastItem="true" />
    </div>
</div>`;
// Exports
export default code;